import { useRef, useState, useEffect } from 'react'
import { downloadAppEvent, getSearchParams, openIsales } from '../../controller/common'
// import HelpAndVersion from './HelpAndVersion'
import './index.css'
import IOSInfo from './IOSInfo'
import Mask from './Mask'
import Reminder from './Reminder'
import { getSignature } from '../../http/http'
import { SIGNATURE } from '../../http/url'

// document.addEventListener('WeixinOpenTagsError', function (e: any) {
//     console.error(e.detail.errMsg)
// })


export const MobilePage = (props: any) => {
    // console.log(props)
    const [showReminder, setShowReminder] = useState(false)
    const [showmask, setShowmask] = useState(false)
    const [showDownload, setShowDownload] = useState(false)
    // const platForm = props.platform.iOS ? 'ios' : 'android'
    const controlShowEvent = (flag = false) => {
        if (props.platform.wechat) {
            setShowmask(true)
            return
        }
        if (flag) {
            setShowReminder(true)
        } else {
            setShowReminder(false)
            downloadAppEvent(props.platform, (link: string) => {
                console.log(link)
                window.location.href = props.platform.iOS ? 'itms-services://?action=download-manifest&url=' + link : link
            })
        }
    }
    const wxRef: any = useRef(null)
    const params = getSearchParams()

    let data: any = {}
    const pageId = params.get('pageId')
    const code = params.get('code')
    const customBtn = params.get('cusBtn')
    const cusLink = params.get('cusLink')
    // params.forEach((value, key) => {
    //     data[key] = value
    // })
    if (pageId) {
        // const paramToSend = getPlatForm().android ? params.toString() : encodeURIComponent(params.toString())
        data = (`isales://com.taikanglife.isalessystem.test/jump?platform=yes&pageId=${pageId}&param=${encodeURIComponent(params.toString())}`)
    } else {
        data = (`isales://com.taikanglife.isalessystem.test/jump?module=${code || '0000'}`)
    }
    // useEffect(() => {
    //     if (!props.platform.wechat && !props.platform.wework) {
    //         openIsales()
    //     }
    // }, [])
    const insertCodeFn = (name: string, datas: any) => {
        const safn = window.sa(process.env.REACT_APP_ENV !== 'production' ? 'test' : 'pro')
        safn(name, datas)
    }
    // console.log('data for open', data)
    
    const showMaskFn = () => { setShowmask(true) }
    useEffect(() => {
        !cusLink && setShowDownload(true)
    }, [cusLink])
    useEffect(() => {
        try {
            let staff = params.get('staff')
            let arr: any = []
            if (staff) {
                arr = staff.split('_')
            }
            sensors && sensors.registerPage({
                productLine: '泰行销',
                groupId: '3244e9b30e33510b6ae9f7d2c3d7ded5',
                txxId: staff,
                channel: arr[0],
                orgDesc: arr[1],
                userNumber: arr[2]
            })
            autoTrackDuration(process.env.REACT_APP_ENV !== 'production' ? 'test' : 'pro', {
                staffNumber: params.get('staff') || 'empty',
                source: params.get('se') || 'empty',
                title: '泰行销引导页'
            });
            insertCodeFn('guidetxx_view', {
                source: params.get('se'),
                staffNumber: params.get('staff'),
                title: '泰行销引导页'
            })
        } catch (err) { }
       
    }, [params])
    //     <script>
    // </script>
    return <div>
        {props.platform.pc ? <div>请使用移动设备打开</div> :
            <><div className="mobile-cover">
                <div className='mobile-bg' ></div>

                <div className="download-area">
                    <button className={'btn newbtn'} onClick={() => {
                        insertCodeFn('guidetxx_button_click', {
                            staffNumber: params.get('staff'),
                            source: params.get('se'),
                            buttonName: '打开泰行销'
                        });
                        if (props.platform.wechat) {
                            setShowmask(true)
                            return
                        }
                        openIsales(); 
                    }}>打开泰行销</button> 

                    {cusLink && <button className="btn download ios" onClick={(event) => {
                        event.preventDefault();
                        insertCodeFn('guidetxx_button_click', {
                            staffNumber: params.get('staff'),
                            source: params.get('se'),
                            buttonName: customBtn
                        }); window.location.href = cusLink
                    }}>{customBtn}</button>}
                    {showDownload && <button className="btn download ios" onClick={(event) => {
                        event.preventDefault();
                        insertCodeFn('guidetxx_button_click', {
                            staffNumber: params.get('staff'),
                            source: params.get('se'),
                            buttonName: '下载泰行销'
                        }); controlShowEvent(props.platform.iOS)
                    }}>下载泰行销</button>}
                </div>
                <div className="con">
                    {props.platform.iOS ? <IOSInfo /> : props.platform.harmony ? <p>支持HarmonyOS NEXT 5.0及以上版本</p> :  <><p><span style={{color:'red'}}>【重要提醒】</span>鸿蒙系统5.0及以上用户，请前往【华为应用市场】搜索“泰行销NEXT”进行下载安装。</p><p>支持Android 7.0及以上版本</p></>}
                    {/* {props.platform.iOS ? <IOSInfo /> : <p>支持Android 5.0及以上版本</p>} */}
                    {/* <HelpAndVersion /> */}
                </div>
            </div >
                {(props.platform.wechat && showmask) ?  <Mask hideMask={()=> setShowmask(false)}/> : <></>}
                {showReminder ? <Reminder controlShowEvent={controlShowEvent} /> : <></>}
            </>
        }
    </div>
}
